import { render, staticRenderFns } from "./ListTardanzas.vue?vue&type=template&id=2f297fec&scoped=true"
import script from "./ListTardanzas.vue?vue&type=script&lang=js"
export * from "./ListTardanzas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f297fec",
  null
  
)

export default component.exports